import { Cross2Icon, PlusIcon } from '@radix-ui/react-icons';
import { Button, Callout, Flex } from '@radix-ui/themes';
import { QueryStatus } from 'react-query';
import { ErrorState } from './EmptyState';
import SkeletonLoader from './SkeletonLoader';

interface IListsProps {
    status: QueryStatus;
    TableComponent: () => React.ReactNode;
    handleClickCreate?: (...args: any[]) => void;
    handleClickBack?: (...args: any[]) => void;
    handleClickCreateText?: string;
}

export const Lists = ({ status, TableComponent, handleClickCreate, handleClickBack, handleClickCreateText = "Registar" }: IListsProps) => {
    switch (status) {
        case 'error':
            return <ErrorState />;
        case 'idle':
            return (
                <Callout.Root color="gray">
                    <Callout.Text>Nenhuma acção em andamento.</Callout.Text>
                </Callout.Root>
            );
        case 'loading':
            return <SkeletonLoader />;
        case 'success': {
            const hasActions =
                typeof handleClickCreate === 'function' || typeof handleClickBack === 'function';

            return (
                <Flex direction="column" gap="4">
                    {hasActions && (
                        <Flex gap="3" align="center" wrap="wrap">
                            {typeof handleClickCreate === 'function' && (
                                <Button onClick={handleClickCreate}>
                                    <PlusIcon /> {handleClickCreateText}
                                </Button>
                            )}
                            {typeof handleClickBack === 'function' && (
                                <Button color="red" variant="soft" onClick={handleClickBack}>
                                    <Cross2Icon /> Cancelar
                                </Button>
                            )}
                        </Flex>
                    )}
                    {TableComponent()}
                </Flex>
            );
        }
        default:
            return null;
    }
};
